export interface CroppedAreaProps {
  x: number;
  y: number;
  width: number;
  height: number;
}

export function executeImageCrop(
  croppedAreaPixels: CroppedAreaProps,
  {
    file,
    readResult,
  }: {
    file: File;
    readResult: string;
  },
): string | void {
  const canvas = document.createElement('canvas');
  const imageRef = document.createElement('img');

  imageRef.src = readResult;

  const scaleX = imageRef.naturalWidth / imageRef.width;
  const scaleY = imageRef.naturalHeight / imageRef.height;
  const targetWidth = 256;
  const targetHeight = croppedAreaPixels.height * (targetWidth / croppedAreaPixels.width);
  canvas.width = targetWidth;
  canvas.height = targetHeight;
  const canvasContext = canvas.getContext('2d');

  if (!canvasContext) return;

  canvasContext.drawImage(
    imageRef,
    croppedAreaPixels.x * scaleX,
    croppedAreaPixels.y * scaleY,
    croppedAreaPixels.width * scaleX,
    croppedAreaPixels.height * scaleY,
    0,
    0,
    targetWidth,
    targetHeight,
  );

  return canvas.toDataURL(file.type);
}
